import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxPpsrGrantorSearchRequest } from '../../../../types/plugins';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxPpsrGrantorSearchRequest } from '../../requests/runEquifaxPpsrGrantorSearchRequest';

export const useRunEquifaxPpsrGrantorSearchRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxPpsrGrantorSearchRequest) =>
      runEquifaxPpsrGrantorSearchRequest(constructPost, data),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxPpsrGrantorSearchRequest: mutateAsync, ...rest };
};
